module.exports = __webpack_public_path__ + "img/ico-qrcode.9e7c35fa.jpg";